import api from 'api'
import { CACHE_TAG_ACCOUNT_GROUP_LIST, CACHE_TAG_ACCOUNT_GROUP_DETAILS } from '../../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    updateAccountGroup: build.mutation({
      query: ({ accountGroupId, body }) => ({ url: `/api/v1/core/accounts/groups/${accountGroupId}`, method: 'PUT', body }),
      invalidatesTags: (result, error, arg) => [
        CACHE_TAG_ACCOUNT_GROUP_LIST,
        { type: CACHE_TAG_ACCOUNT_GROUP_DETAILS, id: arg.accountGroupId },
      ],
    }),
  }),
})

export const { useUpdateAccountGroupMutation } = extendedApi
